import { render, staticRenderFns } from "./StudentCourses.vue?vue&type=template&id=794b62ac&scoped=true&"
import script from "./StudentCourses.vue?vue&type=script&lang=js&"
export * from "./StudentCourses.vue?vue&type=script&lang=js&"
import style0 from "./StudentCourses.vue?vue&type=style&index=0&id=794b62ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b62ac",
  null
  
)

export default component.exports